import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components";
import API from "@beardeddevops/react.api";

import Tooltip from '@material-ui/core/Tooltip';
import {Alert, Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";
import UniversalModalOverride from "components/UniversalModalOverride";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Access from "constants/Access";

/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
class CustomerEditObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Customers._name);
		// this.state.us_born = true;

		this.afterLegalEntitySave = this.setNewObject('legal_entity', 'legal_entities');
	}

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Customers_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	handleOptInToggle = (property) => {
		this.setState((state) => ({
			[property]: !state[property],
			[property + '_error']: '',
		}));
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Customers_Object} data
	 */
	loadSelfAfter(data) {
		this.setState({'us_born': !(!!data.birth_country)});
		if (typeof this.props.loadContacts === 'function') {
			this.props.loadContacts({
				phones: data.customer_numberss,
				emails: data.customer_emailss,
				addresses: data.customer_addressess,
				blacklist: data.blacklist,
				identification: data.customer_identificationss.length > 0 ? data.customer_identificationss[0] : null,
				permit: data.customer_permitss.length > 0 ? data.customer_permitss[0] : null,
				militaries: data.customer_militaries,
			});
		}
		//CRM: hand the full customer object to the CRM tab so it can render
		//tracked fields (language, opt-ins + audit dates, last contact) without a
		//second API call.
		if (typeof this.props.loadCrmData === 'function') {
			this.props.loadCrmData(data);
		}
	};


	copyCustomerToPos = async () => {
		let cModel = new API.BuildClass(Types.Customers._name, 'POST_POS');
		let result = await cModel.submit(this, 'POST_POS');
	}

	form = () => {
		/** @type {Customers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					{object && object.blacklist &&
					<Alert color="danger">
						<p style={{fontSize: '18px', marginBottom: '0px'}}>
							{/*<Button color={'danger'} size={'sm'} className={'pull-right'}*/}
							{/*        style={{marginRight: '-6px', marginLeft: '15px', marginTop: '-2px'}}>*/}
							{/*	<i className="fa fa-trash"/>&nbsp;&nbsp;Remove From List*/}
							{/*</Button>*/}
							This customer has been added to your blacklist with the following
							reason, <b>"{object.blacklist_reason}"</b>.<br/>This warning will appear on any future dispositions unless
							they are removed from the list.
						</p>
					</Alert>}

					<div className={"row"}>
						{/*#region Column 1*/}
						<div className={"col-md"}>

							{/*#region Customer Information*/}
							<h4 className="section-title">Customer Information</h4>
							<Parts.CustomerName
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
							/>
							{/*#endregion*/}

							{/*#region Place of Birth, Birth Date*/}
							<h4 className="section-title">Place of Birth, Birth Date</h4>
							<div className="form-group">
								<Framework.Elements.Date
									label={"Birth Date"}
									property={properties.birth_date}
									value={object.birth_date}
									update={this.handleTextFieldPropertyUpdate}
									disableFutureDates={true}
								/>
							</div>

							{(this.props.rootState && this.props.rootState.crmAvailable) &&
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: 'English', name: 'English'},
										{pkey: 'Spanish', name: 'Spanish'},
										{pkey: 'Chinese', name: 'Chinese'},
										{pkey: 'Vietnamese', name: 'Vietnamese'},
										{pkey: 'Tagalog / Filipino', name: 'Tagalog / Filipino'},
										{pkey: 'Arabic', name: 'Arabic'},
										{pkey: 'French', name: 'French'},
										{pkey: 'Korean', name: 'Korean'},
										{pkey: 'Other', name: 'Other'},
									]}
									property={properties.language}
									value={object.language}
									error={object.language_error}
									text={'name'}
									labelWidth={5}
									label="Language"
									limit={null}
									/>
									</div>}

									{(this.props.rootState && this.props.rootState.crmAvailable) &&
									<div className="form-group">
									<Framework.Elements.Checkbox
										property={properties.email_opt_in}
										value={object.email_opt_in}
										error={object.email_opt_in_error}
										update={() => this.handleOptInToggle('email_opt_in')}
										label="Opt in to email marketing"
										color='primary'
									/>
									</div>}
									{(this.props.rootState && this.props.rootState.crmAvailable) &&
									<div className="form-group">
									<Framework.Elements.Checkbox
										property={properties.sms_opt_in}
										value={object.sms_opt_in}
										error={object.sms_opt_in_error}
										update={() => this.handleOptInToggle('sms_opt_in')}
										label="Opt in to text (SMS) messages"
										color='primary'
									/>
									</div>}

									<div className={"row"}>
									<div className="col-lg-auto">
										<div className="form-group">
											<Framework.Elements.ButtonSwitch
												property={properties.us_born}
											value={object.us_born}
											error={object.us_born_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'U.S.'}
											labelFalse={'Foreign'}
										/>
									</div>
								</div>
								<div className="col-lg">

									{this.state.us_born === true ?
										<div className="row">
											<div className="col-md">
												<div className="form-group">
													<Framework.Elements.TextField
														property={properties.birth_city}
														value={object.birth_city}
														error={object.birth_city_error}
														update={this.handleTextFieldPropertyUpdate}
													/>
												</div>
											</div>
											<div className="col-md">
												<div className="form-group">
													<Framework.Elements.Select
														shouldLoad={this.state.loaded}
														update={this.handleSelectPropertyUpdate}
														property={properties.birth_state}
														value={object.birth_state}
														error={object.birth_state_error}
														id="short"
														model={Types.States._name}
														nullable={false}
														limit={null}
													/>
												</div>
											</div>
										</div>
										:

										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.birth_country}
												value={object.birth_country}
												error={object.birth_country_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									}

								</div>
							</div>

							{/*#endregion*/}

							{/*#region Height (ft,in), Weight (Lbs), Sex*/}
							<h4 className="section-title">Height (ft,in), Weight (Lbs), Sex</h4>

							<div className={"d-flex"}>
								<div className="form-group pr-1">
									<Framework.Elements.NumberField
										property={properties.height_ft}
										value={object.height_ft}
										error={object.height_ft_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group pr-1 pl-1">
									<Framework.Elements.NumberField
										property={properties.height_in}
										value={object.height_in}
										error={object.height_in_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group pr-1 pl-1">
									<Framework.Elements.NumberField
										property={properties.weight}
										value={object.weight}
										error={object.weight_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group pl-1" style={{minWidth: '200px'}}>
									<Framework.Elements.Select
										shouldLoad={this.state.loaded}
										update={this.handleSelectPropertyUpdate}
										objects={[
											{pkey: 'M', name: 'Male'},
											{pkey: 'F', name: 'Female'},
											{pkey: 'O', name: 'Non-Binary'},
										]}
										property={properties.gender}
										value={object.gender}
										error={object.gender_error}
										text={'name'}
										nullable={false}
										limit={null}
									/>
								</div>
							</div>
							{/*#endregion*/}

							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
									label={'Notes'}
								/>
							</div>

						</div>
						{/*#endregion Column 1*/}
						{/*#region Column 2*/}
						<div className={"col-md"}>

							{/*#region Residency, Citizenship*/}
							<h4 className="section-title">Residency, Citizenship</h4>

							<div className={"row"}>
								<div className="col-6">
									<div className="form-group">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.state_of_residence}
											value={object.state_of_residence}
											error={object.state_of_residence_error}
											id={'short'}
											model={Types.States._name}
											nullable={false}
											limit={null}
										/>
									</div>
								</div>
								<div className="col-6" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.us_citizen}
											value={object.us_citizen}
											error={object.us_citizen_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'U.S.'}
											labelFalse={'Other'}
										/>
									</div>
								</div>
							</div>


							{object.us_citizen === false ?
								<div className={"row"}>
									<div className={"col-md-6"}>
										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.foreign_citizenship}
												value={object.foreign_citizenship}
												error={object.foreign_citizenship_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={"col-md-6"}>


										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.alien_number}
												value={object.alien_number}
												error={object.alien_number_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>


									</div>
								</div> : null}


							{/*#endregion*/}

							{/*#region Ethnicity*/}
							<h4 className="section-title">Ethnicity</h4>
							<div className="row">
								<div className="col-7">
									<span className="input-label">Hispanic / Latino</span>
								</div>
								<div className="col-5" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.ethnicity_hispanic}
											value={object.ethnicity_hispanic}
											error={object.ethnicity_hispanic_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}

							{/*#region Race*/}
							<h4 className="section-title">Race</h4>

							{/*#region AM Indian or AK Native*/}
							<div className="row">
								<div className="col-7">
									<span className="input-label">
										<Tooltip title="American Indian" aria-label="American Indian">
											<u className="dotted">AM </u>
										</Tooltip>
										Indian or
										<Tooltip title="Alaska Native" aria-label="Alaska Native">
											<u className="dotted"> AK </u>
										</Tooltip>
										Native
									</span>
								</div>
								<div className="col-5" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.race_american_indian}
											value={object.race_american_indian}
											error={object.race_american_indian_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}

							{/*#region Asian*/}
							<div className="row">
								<div className="col-7">
									<span className="input-label">Asian</span>
								</div>
								<div className="col-5" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.race_asian}
											value={object.race_asian}
											error={object.race_asian_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}

							{/*#region Black or African American*/}
							<div className="row">
								<div className="col-7">
									<span className="input-label">Black or African American</span>
								</div>
								<div className="col-5" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.race_african_american}
											value={object.race_african_american}
											error={object.race_african_american_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}

							{/*#region Native HAW / Pacific Isl.*/}
							<div className="row">
								<div className="col-7">
									<span className="input-label">
										Native
										<Tooltip title="Native Hawaiian or Other Pacific Islander"
										         aria-label="Native Hawaiian or Other Pacific Islander">
											<u className="dotted"> HAW </u>
										</Tooltip>
										/ Pacific Isl.
									</span>
								</div>
								<div className="col-5" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.race_native_hawaiian}
											value={object.race_native_hawaiian}
											error={object.race_native_hawaiian_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}

							{/*#region White*/}
							<div className="row">
								<div className="col-7">
									<span className="input-label">White</span>
								</div>
								<div className="col-5" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.race_white}
											value={object.race_white}
											error={object.race_white_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion White*/}

							{/*#endregion Race*/}

						</div>
						{/*#endregion Column 2*/}
						{/*#region Column 3*/}
						<div className={"col-md"}>

							{/*#region Additional Information*/}
							<h4 className="section-title">Additional Information</h4>

							{/*#region Type*/}
							<div className="row">
								<div className="col-sm">
									<span className="input-label">Type</span>
								</div>
								<div className="col-sm" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.company}
											value={object.company}
											error={object.company_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Business'}
											labelFalse={'Individual'}
										/>
									</div>
								</div>
							</div>
							{object.company === true ?
								<div className="form-group">
									<Framework.Elements.TextField
										key={this.state.key}
										label={"Company Name"}
										value={object.name_company}
										error={object.name_company_error}
										property={properties.name_company}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								: null}

							{/*#endregion White*/}
							{/*#endregion*/}

							{/*#region SSN*/}
							<h4 className="section-title">SSN</h4>
							<div className="form-group">
								<Framework.Elements.NumberField
									label={"S.S.N."}
									value={object.ssn}
									error={object.ssn_error}
									property={properties.ssn}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}

							{/*#region UPIN*/}
							<h4 className="section-title">UPIN</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"U.P.I.N."}
									value={object.upin}
									error={object.upin_error}
									property={properties.upin}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}

							<h4 className="section-title">Trust / Legal Entity Information</h4>
							<Parts.TransactionLegalEntity
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterLegalEntitySave={this.afterLegalEntitySave}
							/>

						</div>
						{/*#endregion Column 3*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					title={"Start 4473"}
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					object={Objects.OnePage}
					objectProps={{
						customer: this.props.id,

					}}
					name={"Start"}
					toggle={this.state['modalOnePage']}
					reportClose={this.reportClose('modalOnePage')}
					afterSave={this.handleAfterSave}
					size={'xl'}
				/>
			</div>
		)
	};
	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px'}}>
					<Button color="blue-hoki" onClick={this.toggle('modalOnePage')}>
						<i className={"fa fa-arrow-right"}/> Start 4473
					</Button>
					<Button color="secondary" onClick={this.copyCustomerToPos}>
						Copy Customer To POS
					</Button>
					<div style={{display: 'flex', gap: '8px'}}>
						<Button color="danger" onClick={this.handleDelete}>Delete</Button>
						<Button color="primary" onClick={this.handleSubmit}>Save</Button>
					</div>
				</CardActions>
			</Card>
		)
	}

}

export default Framework.Components.withRootState(CustomerEditObject);
